// extracted by mini-css-extract-plugin
export var caractere = "testimonie-diapo-module--caractere--af53a";
export var citation = "testimonie-diapo-module--citation--d429c";
export var containerLink = "testimonie-diapo-module--containerLink--5787a";
export var detailText = "testimonie-diapo-module--detailText--86ed9";
export var job = "testimonie-diapo-module--job--57138";
export var linkLabel = "testimonie-diapo-module--linkLabel--0be89";
export var main = "testimonie-diapo-module--main--9a4ec";
export var more = "testimonie-diapo-module--more--d9b41";
export var title = "testimonie-diapo-module--title--14e20";